import { render, staticRenderFns } from "./CalendarAltIcon.vue?vue&type=template&id=7f824aaf"
import script from "./CalendarAltIcon.vue?vue&type=script&lang=js"
export * from "./CalendarAltIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports